import { sagas as projectsSagas } from './modules/projects'
import { sagas as projectAllowanceSagas } from './modules/projectAllowance'
import { sagas as documentsSagas } from './modules/documents'

export default [
  ...projectsSagas,
  ...projectAllowanceSagas,
  ...documentsSagas,
]
